class StandardBehaviour{
    static responseHandling(response){
        return response.json();
    }
    static isError(response){
        return false; 
    }
    static errorMessage(response){
        return ""; 
    }
}
export default StandardBehaviour; 